export const toRepresentativeName = (withIds: Record<string, number | string>, withNames: Record<string, number | string>) =>
  Object.entries(withIds)
    .filter(([key]) => Number.isNaN(Number.parseInt(key)))
    .reduce((acc, [key, value]) => {
      return {
        ...acc,
        [value]: withNames[key],
      };
    }, {});
